const marcomFetch = async (input: RequestInfo, init?: RequestInit): Promise<Body> => {
  const response = await fetch(input, init)
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}

export default marcomFetch
